export default __webpack_public_path__ + "static/Select relevant LFI from libray-7d79ef50c682bfa1104a0145b2f0bf82.jpg";